import React from "react";

import { FaBus } from "react-icons/fa6";

const LoadingIndicator = () => {
  return (
    <div className="w-full flex flex-col items-center mt-5 mb-2">
      <FaBus className="animate-pulse w-28 h-28 mt-8 mb-4 text-rose-700" />
      Just a few moment
    </div>
  );
};

export default LoadingIndicator;
